import { array, boolean, defineAction, enumerated, number, object, string } from '~/prix'
import geoListAction from './geoList.action.json' with { type: 'json' }
import { spaceForPoint } from '~/prix/types/presets/space'
import any from '~/prix/types/any'
import { Space } from '~/packages/variable/spaceTime.types'

const geoListDefinition = defineAction({
  ...geoListAction,

  input: object({
    spaces: array(spaceForPoint()).isOptional(),
    highResolution: boolean().isOptional(),
    query: string().isOptional(),
    limit: number().isOptional(),
    include: array(
      enumerated({
        geometry: 'Geometry',
      }),
    ).isOptional(),
    isSearch: boolean().isOptional(),
  }),
  output: object({
    items: array(
      object({
        id: number(),
        name: string(),
        shape: any().isOptional(),
        shapeUrbanArea: any().isOptional(),
        point: any().isOptional(),
        path: any().isOptional(),
        subtitle: string().isOptional(),
      }),
    ),
  }),
  cache: input => {
    if (
      input.highResolution ||
      input.spaces?.some((space: Space) => space.delimitationType === 'custom')
    ) {
      return {}
    }
    return {
      back: {
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 7, // 7 days
        expirationMsForUpdate: 1000 * 60 * 60 * 24 * 1, // 1 day
      },
      front: {
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 7, // 7 days
        expirationMsForUpdate: 1000 * 60 * 60 * 24 * 1, // 1 day
      },
    }
  },
})

export default geoListDefinition
